 export const updateEmpTime = () => ({
  type: "UPDATE_TIME"
})